// @ts-nocheck
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CKEditor from 'ckeditor4-react';
import { Spin, Form } from 'antd';
import { CLOUDINARY_CLOUDNAME, CLOUDINARY_PRESET } from '../../../config';
import { withHTMLFieldValue } from 'modules/look';

const editorVersion = '4.15.1';
const editorUrl = `https://cdn.ckeditor.com/${editorVersion}/full-all/`;

CKEditor.editorUrl = `${editorUrl}ckeditor.js`;

const CKEditorFieldSurvey = props => {
  const FormItem = Form.Item;
  const [loaded, setLoaded] = useState(false);
  const {
    label,
    value,
    name,
    disabled,
    rules,
    initialValue,
    onChange,
    style,
    hideToolBar,
    height,
    displayFeild,
    removeMargin,
    width,
    onBlur,
    required,
    ...rest
  } = props;

  const cloudName = `${CLOUDINARY_CLOUDNAME}/image`;
  const unsignedUploadPreset = `${CLOUDINARY_PRESET}`;

  if (typeof window !== 'undefined') {
    // To load the script -> <script src="https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"></script>
    const scr = document.createElement('script');
    const head = document.head || document.getElementsByTagName('head')[0];
    scr.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
    scr.async = false;
    head.insertBefore(scr, head.firstChild);
  }

  return (
    <div style={style}>
      <FormItem required={required} {...rest}>
        <div className='survey-ck-editior-view'>
          <CKEditor
            className="one-on-one-custom-ck"
            name={Array.isArray(name) ? name.join('.') : name}
            mode="wysiwyg"
            data={withHTMLFieldValue(initialValue)}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={false}
            config={{
              extraPlugins: ['image2'],
              font_names: 'Poppins;Arial;Times New Roman;Verdana;Comic Sans MS;Courier New;Georgia;Lucida Sans Unicode;Tahoma;Trebuchet Ms',
              contentsCss: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap',
              removePlugins: ['contextmenu', 'forms', 'bidi', 'div', 'flash', 'iframe', 'about', 'source'],
              toolbar: [
                { name: 'styles', items: ['Format'] },
                {
                  name: 'basicstyles',
                  groups: ['basicstyles', 'cleanup'],
                  items: ['Bold', 'Italic', 'Underline']
                },
                {
                  name: 'paragraph',
                  groups: ['list', 'indent', 'blocks', 'align', 'bidi'],
                  items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
                },
                { name: 'links', items: ['Link'] }
              ],
              uiColor: '#ffffff',
              allowedContent: true,
              height: height ? height : 180,
              width: width ? width : null,
              language: 'en',
              disableNativeSpellChecker: true,
              browserContextMenuOnCtrl: false,
              forcePasteAsPlainText: true,
              on: {
                loaded: function () {
                  setLoaded(true);
                },
                instanceReady: function (evt) {
                  const editor = evt.editor;
                  editor.on('contentDom', function () {
                    editor.document.getBody().on('contextmenu', function (event) {
                      event.data.preventDefault(true);
                    });
                  });

                  // Grammarly workaround
                  editor.document.getBody().setAttribute('data-gramm', 'false');
                  editor.document.getBody().setAttribute('data-gramm_editor', 'false');
                  editor.document.getBody().setAttribute('data-enable-grammarly', 'false');

                  // Disable right-click
                  editor.document.on('contextmenu', function (e) {
                    e.data.preventDefault(true);
                  });

                  // Disable Ctrl+C / Ctrl+V
                  editor.document.on('keydown', function (event) {
                    const e = event.data.$;
                    if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'v' || e.keyCode === 67 || e.keyCode === 86)) {
                      event.data.preventDefault(true);
                    }
                  });

                  // Disable paste events
                  editor.on('paste', function (event) {
                    event.cancel();
                  });
                },
                fileUploadRequest: function (evt) {
                  // Prepare request to Cloudinary
                  var url = 'https://api.cloudinary.com/v1_1/' + cloudName + '/upload';
                  var xhr = evt.data.fileLoader.xhr;
                  xhr.open('POST', url, true);
                  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                  // Fill all necessary fields for Cloudinary
                  // eslint-disable-next-line no-undef
                  var fd = new FormData();
                  fd.append('upload_preset', unsignedUploadPreset);
                  // fd.append('folder', 'content/articles'); // Optional - place image at specific folder admin in Cloudinary
                  // fd.append('tags', 'browser_upload'); // Optional - add tag for image admin in Cloudinary
                  fd.append('file', evt.data.fileLoader.file);
                  // Send the request to Cloudinary server
                  xhr.send(fd);

                  // Prevented the default behavior.
                  evt.stop();
                },
                // Change response to handle Cloudinary response
                fileUploadResponse: function (evt) {
                  // Prevent the default response handler.
                  evt.stop();

                  // Get XHR and response.
                  var data = evt.data,
                    xhr = data.fileLoader.xhr,
                    response = JSON.parse(xhr.responseText);

                  // Transfer the response to Ckeditor format
                  data.uploaded = 1;
                  data.fileName = response.public_id + '.' + response.format;
                  data.url = response.secure_url;
                }
              }
            }}
            // onSelectionChange={changeHandler}
            onBeforeLoad={CKEDITOR => {
              // CKEDITOR.plugins.addExternal('ckeditor_wiris', 'https://www.wiris.net/demo/plugins/ckeditor/', 'plugin.js');
              CKEDITOR.plugins.addExternal(
                'image2',
                `https://ckeditor.com/docs/vendors/${editorVersion}/ckeditor/plugins/image2/`,
                'plugin.js'
              );
            }}
          />
        </div>
      </FormItem>
      {!loaded && (
        <div style={{ height: '100%' }} align="center">
          <Spin style={{ margin: 'auto' }} />
        </div>
      )}
    </div>
  );
};

CKEditorFieldSurvey.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  inFilter: PropTypes.bool,
  meta: PropTypes.object,
  formik: PropTypes.object
};

export default CKEditorFieldSurvey;